export default __webpack_public_path__ + "static/media/play.dba0ad22.svg";